import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout } from "banafo-design-system";
import Header from "./Header";
import Title from "./Title";
import Invoices from "src/features/invoices/Invoices";
const InvoicesPage = () => {
    return (_jsxs(Layout, { header: _jsx(Header, {}), scrollBar: 1, options: {
            contentProps: { className: "px-200" }
        }, children: [_jsx(Title, {}), _jsx(Invoices, {})] }));
};
export default InvoicesPage;
